export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';
export const USER_LOADED = 'USER_LOADED';
export const AUTH_ERROR = 'AUTH_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT = 'LOGOUT';
export const ACCOUNT_DELETED = 'ACCOUNT_DELETED';
export const GET_USER_CONTACTS = 'GET_USER_CONTACTS';
export const GET_USER_CONTACTS_FAIL = 'GET_USER_CONTACTS_FAIL';
export const SELECT_CONTACT = 'SELECT_CONTACT';
export const SELECT_GROUP = 'SELECT_GROUP';
export const GET_ALL_MESSAGES = 'GET_ALL_MESSAGES';
export const SEND_MESSAGE = 'SEND_MESSAGE';
export const SET_ARRIVAL_MESSAGE = 'SET_ARRIVAL_MESSAGE';
export const UPDATE_USER_PROFILE = 'UPDATE_USER_PROFILE';
